import { Autocomplete, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, TextField, Tooltip, Typography } from '@mui/material';
import { useEffect, useState } from 'react'
import { ButtonLoader } from '../../../../shared_elements/components';
import LessMoreTextFieldComp from '../../../../shared_elements/components/LessMoreTextFieldComp';
import { useDispatch, useSelector } from 'react-redux';
import { regexConstants } from '../../../../constants/regEx';
import { globalPostService, globalPutService } from '../../../../utils/globalApiServices';
import { checkApiStatus, getTextFieldRows, numberWithCommas, formatCycles } from '../../../../utils';
import { enqueueSnackbar } from 'notistack';
import { useParams } from 'react-router';
import { assetTypeMap } from '../../../leases/components/LeaseConstants';
import { addAssemblysApi, updateAssemblysApi } from '../apiService';
import { getAssemblysApi } from '../../../../shared_elements/actionCreators';
import { trackActivity } from '../../../../utils/mixpanel';
import InfoIcon from '@mui/icons-material/Info'

const AddAssemblys = ({ onToggleModal, getResponseBack, assemblysType, modeType, addAssemblys, setAddAssemblys }) => {
  const dispatch = useDispatch()
  const params = useParams();
  const { assemblysList } = useSelector((state) => state.leases);
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState({ ...addAssemblys?.data, assemblies: addAssemblys?.data?.asset });
  const [error, setError] = useState({});
  const [isDropDownLoading, setIsDropDownLoading] = useState({ assembly: !(assemblysList?.length > 0) });

  useEffect(() => {
    if (!assemblysList.length) {
      dispatch(getAssemblysApi(params, { setIsDropDownLoading: setIsDropDownLoading }));
    }
  }, [])

  const onRestErrorKey = (key) => {
    setError((prev) => ({ ...prev, [key]: '' }));
  };

  const onFieldChange = (key, value) => {
    setData({ ...data, [key]: value });
    setError((prev) => ({ ...prev, [key]: '' }));
  };


  const onAddAssemblys = () => {
    const validationInputs = {
      assemblies: data?.assemblies ? "" : "Please select Assembly",
    };
    if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
      setLoading(true);
      const { assemblies, ...restData } = data
      const payload = { ...restData, asset_slug: data?.assemblies?.asset_slug, asset_type: assetTypeMap[data?.assemblies?.asset_type] }
      const serviceCall = data.id ? globalPutService(updateAssemblysApi({ ...params, assembly_slug: data?.slug }), payload) : globalPostService(addAssemblysApi(params), payload);
      serviceCall.then(async (response) => {
        if (checkApiStatus(response)) {
          enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          onToggleModal()
          getResponseBack();
          setLoading(false);
          trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `Return Condition ${modeType === 'add' ? 'Add' : 'Edit'} Assembly`, success_msg: response?.data?.message, item_slug: params?.leaseSlug, payload: payload, response: response?.data })
        } else {
          setLoading(false);
          enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `Return Condition ${modeType === 'add' ? 'Add' : 'Edit'} Assembly`, error_msg: response?.data?.message, item_slug: params?.leaseSlug, payload: payload, response: response?.data })
        }
      });
    } else {
      setError(validationInputs);
      trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `Return Condition ${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Assembly`, error_msg: validationInputs, })
    }
  };

  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Return Condition ${modeType === 'add' ? 'Add' : 'Edit'} Assembly`, page_type: page_type, })
  }
  return (
    <>
      <Dialog
        onClose={(event, reason) => { if (reason !== 'backdropClick') { onToggleModal(); } }}
        disableEscapeKeyDown
        aria-labelledby="customized-dialog-title"
        className="add-lease-dialog"
        maxWidth="md"
        slotProps={{ paper: { sx: { width: '480px', margin: 'auto', top: '14%', transform: 'translateY(-50%)', position: 'relative', } } }}
        open={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
          <Typography sx={{ marginLeft: "10px" }}>
            {data?.id ? `${addAssemblys.mode === "view" ? "View" : "Edit"} Assembly` : "Add Assembly"}
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid size={{ md: 12, xs: 12 }}>
              <Autocomplete
                disablePortal
                disableClearable
                width="100%"
                options={assemblysList.filter(opt => !assemblysType.some(a => a.asset?.id === opt.id)) || []}
                getOptionLabel={(o) => o?.name || ""}
                noOptionsText={isDropDownLoading?.assembly ? "loading" : "No Option Available"}
                value={assemblysList.find((opt) => opt.id === String(data.assemblies)) || data.assemblies}
                onChange={(e, val) => onFieldChange("assemblies", val)}
                onFocus={() => onRestErrorKey("assemblies")}
                disabled={modeType === 'view'}
                slotProps={{ listbox: { style: { maxHeight: 100, overflowY: "auto" } }, input: { sx: { boxSizing: "border-box", width: "auto" }, }, }}
                renderInput={(params) => {
                  const selectedLabel = params?.inputProps?.value || "";
                  return (
                    <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow>
                      <TextField
                        {...params}
                        label="Assembly"
                        margin="normal"
                        size="small"
                        required
                        fullWidth
                        slotProps={{
                          inputLabel: { shrink: true, }, input: { ...params?.InputProps, endAdornment: (<>{isDropDownLoading?.assembly ? (<CircularProgress color="inherit" size={20} />) : null}{params?.InputProps?.endAdornment}</>) }
                        }}
                        error={Boolean(error.assemblies)}
                        helperText={error.assemblies ?? null}
                        disabled={modeType === "view"}
                      />
                    </Tooltip>)
                }}
              />
            </Grid>
            {modeType === "view" ? (
              <Grid size={{ md: 12, xs: 12 }}>
                <LessMoreTextFieldComp label="Reading" value={data?.reading || ""} rows={getTextFieldRows(data?.reading, 3, 45)} />
              </Grid>
            ) : (
              <Grid size={{ md: 12, xs: 12 }}>
                <TextField
                  id="reading"
                  value={data?.reading || ''}
                  label="Reading"
                  variant="outlined"
                  size="small"
                  margin="normal"
                  fullWidth
                  slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 255 } }}
                  multiline
                  rows={getTextFieldRows(data?.reading, 3, 45)}
                  onChange={(e) => {
                    regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("reading", e.target.value.trimStart()) : e.preventDefault();
                  }}
                />
              </Grid>
            )}
            <Grid size={{ md: 4, xs: 12 }} m={0}>
              <TextField
                disabled={modeType === "view"}
                label="Base TSN"
                variant="outlined"
                size="small"
                margin="normal"
                readOnly={true}
                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 12, inputMode: "decimal" } }}
                value={modeType === "view" && data?.tsn !== '' && data?.tsn !== null && data?.tsn !== undefined ? numberWithCommas(data?.tsn) : (data?.tsn || "")}
                onChange={(e) => { const value = e.target.value; if (regexConstants?.decimalnodotstart.test(value)) { onFieldChange("tsn", value); } }}
                fullWidth
              />
            </Grid>
            <Grid size={{ md: 4, xs: 12 }}>
              <TextField
                label="Base CSN"
                variant="outlined"
                size="small"
                margin="normal"
                fullWidth
                value={modeType === "view" && data?.csn !== '' && data?.csn !== null && data?.csn !== undefined ? formatCycles(data?.csn) : (data?.csn || "")}
                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 12, inputMode: "decimal" } }}
                onChange={(e) => { const value = e.target.value; if (regexConstants?.decimalnodotstart.test(value)) { onFieldChange("csn", value); } }}
                disabled={modeType === "view"}
              />
            </Grid>
            {data?.assemblies?.asset_type === 1 ? (
              <Grid size={{ md: 4, xs: 12 }}>
                <TextField
                  id='block_hours'
                  label={
                    <span style={{ verticalAlign: 'super' }}>
                      BH
                      <Tooltip placement='right' title={<span>Block Hours</span>} arrow>
                        <InfoIcon fontSize='small' color='primary' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                      </Tooltip>
                    </span>
                  }
                  variant="outlined"
                  size="small"
                  margin="normal"
                  fullWidth
                  value={modeType === "view" && data?.block_hours !== '' && data?.block_hours !== null && data?.block_hours !== undefined ? numberWithCommas(data?.block_hours) : (data?.block_hours || "")}
                  slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 12, inputMode: "decimal" } }}
                  onChange={(e) => { const value = e.target.value; if (regexConstants?.decimalnodotstart.test(value)) { onFieldChange("block_hours", value); } }}
                  disabled={modeType === "view"}
                />
              </Grid>) : null}
            
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-action">
          <Button className="cancel-btn" disabled={isLoading} variant="outlined" size="small" onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
          {modeType !== "view" && <Button variant="contained" size="small" className="btn-primary" onClick={() => { handleItemClicked('Save Button'); onAddAssemblys(); }}>{isLoading ? <CircularProgress color='inherit' size={25} /> : "SAVE"}</Button>}
        </DialogActions>
      </Dialog>
    </>
  )
}

export default AddAssemblys